<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <h2>Prestação de Contas</h2>
      <p>
        Acompanhe com transparência a saúde financeira do seu condomínio.<br>
        <b>Lembre-se: </b> Prestações de contas em andamento ou ainda não aprovadas podem sofrer alterações a qualquer momento sem aviso prévio.
      </p>
    </b-col>
    <b-col
      cols="12"
      class="mt-0"
    >
      <list-prestacoes-conta />
    </b-col>
  </b-row>
</template>

<script>
import ListPrestacoesConta from './ListPrestacoesConta.vue'

export default {
  components: {
    ListPrestacoesConta,
  },
}
</script>
